module.exports = __webpack_public_path__ + "img/section10_fr.49285d2.png";